import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatcher } from "../../custom_hooks/use_app_dispatch";
import { ChatActions } from "../../store/slices/chat_slice/chat_slice";

const Timer = memo(({ sessiondata }: any) => {
    const dispatch = useDispatcher();
    const dispositionData: any = useSelector((state: any) => state.dispositionData);
    const [elapsedTime, setElapsedTime] = useState(0);
    const [startTime, setTime] = useState(new Date())

    useEffect(() => {
        if (sessiondata?.dialDuration) {
            setTime(new Date(sessiondata?.dialDuration))
        }
    }, [sessiondata?.dialDuration])

    function formatElapsedTime(time: any) {
        if (!time) return '00:00:00'
        const seconds = Math.floor(time / 1000) % 60;
        const minutes = Math.floor(time / 1000 / 60) % 60;
        const hours = Math.floor(time / 1000 / 60 / 60) % 24;
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
    useEffect(() => {
        if (dispositionData?.sessionId !== sessiondata.sessionId) {
            const updateTimer = () => {
                const now = new Date();
                const time = now.getTime() - startTime.getTime();
                // const time = formatElapsedTime(timeElapsed)
                dispatch(ChatActions.setSessionTime({ sessionId: sessiondata.sessionId, time }));
                setElapsedTime(time);
            };
            updateTimer();
            const interval = setInterval(updateTimer, 1000);
            return () => clearInterval(interval);
        }
    }, [startTime, dispositionData?.sessionId]);

    return <span>{formatElapsedTime(sessiondata?.sessionOnGoingTime)}</span>;
});

export default Timer;
